'use client';
import styles from './sort.module.css';
import { useProperties } from '@/context/properties-context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faFilterList,
	faHandPointLeft,
} from '@awesome.me/kit-012d1b9af0/icons/classic/regular';
import useGeoLocationAddress from '@/hooks/use-location';
import { Properties } from '@/types/properties';
import useModal from '@/components/modal/use-modal';
import FilterModal from '@/components/modal/filter-modal/filter-modal';

export default function Sort() {
	const { properties, updateProperty } = useProperties();
	const { isOpen, onClose, onOpen } = useModal();

	const [_, getLocationAndAddress] = useGeoLocationAddress();

	const handleSortChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
		const oldValue = properties.sortBy;
		const newValue = e.target.value as Properties['sortBy'];

		if (
			newValue === 'distance' &&
			(!properties.location?.lat || !properties.location?.lng)
		) {
			const loc = await getLocationAndAddress();
			if (!loc.latitude || !loc.longitude) return;
		}

		if (oldValue === 'distance' && newValue !== 'distance')
			updateProperty('location', { name: '', lat: 0, lng: 0 });

		updateProperty('sortBy', newValue);
	};

	return (
		<div className={styles.sort}>
			<h3 className={styles.header}>
				<FontAwesomeIcon icon={faHandPointLeft} size='xl' /> Use the filters to
				narrow down the trials that matter most to you
			</h3>
			<div className={styles.filter} onClick={() => onOpen('filter-modal')}>
				<FontAwesomeIcon icon={faFilterList} />
				<span>Filters</span>
			</div>
			<div className={styles['sort-by']}>
				<label className={styles.label} htmlFor='sort'>
					Result Sorted By
				</label>
				<select
					id='sort'
					className={styles.select}
					value={properties.sortBy}
					onChange={handleSortChange}
				>
					<option value='lastPost'>Date Last Posted</option>
					<option value='firstPost'>Date First Posted</option>
					<option value='lastUpdate'>Date Last Updated</option>
					<option value='distance'>Distance From Location</option>
					<option value='status'>Trial Status</option>
				</select>
			</div>

			<FilterModal
				isOpen={isOpen('filter-modal')}
				onClose={() => onClose('filter-modal')}
			/>
		</div>
	);
}
